import classNames from 'classnames';

import RawRenderingService from './raw_rendering_service';

/**
 * Returns raw Html version of React HtmlText component.
 * @param params
 * @returns {String}
 */
export default function htmlTextRenderer(params) {
  const {className = '', text} = params;
  const elem = document.createElement('span');
  elem.className = classNames(className);
  RawRenderingService.appendChildNodeOrHtml(elem, text);
  return elem.outerHTML;
}
